{
  "familyId": "GET-GROOT-VERGELIJK",
  "questions": [
    {
      "id": "GET-GROOT-VERGELIJK-001",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een bibliothecaris sorteert boeken op nummer. Welk getal is het grootst?",
      "context": null,
      "options": ["567", "576", "657", "675"],
      "correctAnswer": 3,
      "conceptId": "compare_three_digit",
      "variantIndex": 1,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.65,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Getallen vergelijken", "content": "Vergelijk cijfer voor cijfer van links naar rechts: honderdtallen eerst, dan tientallen, dan eenheden.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De bibliothecaris vergelijkt cijfer voor cijfer van links naar rechts. Honderdtallen: 5, 5, 6, 6 → 657 en 675 zijn het grootst. Tientallen van 657 en 675: 5 vs 7 → 675 > 657.",
        "solutionSteps": [
          "Vergelijk de honderdtallen: 5, 5, 6, 6",
          "Honderdtal 6 > 5 → 657 en 675 zijn groter",
          "Vergelijk de tientallen: 5 vs 7 → 675 > 657",
          "Antwoord: 675"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 567 het grootst is. Maar het honderdtal is 5, en 657 en 675 hebben honderdtal 6 — die zijn groter. Onthoud: vergelijk altijd eerst de honderdtallen.",
          "1": "Je dacht waarschijnlijk dat 576 het grootst is. Maar het honderdtal is 5. De getallen met honderdtal 6 zijn groter. Onthoud: vergelijk altijd eerst de honderdtallen.",
          "2": "Je dacht waarschijnlijk dat 657 het grootst is. Maar vergelijk met 675: tientalcijfer 5 < 7, dus 675 > 657. Onthoud: bij gelijke honderdtallen vergelijk je de tientallen.",
          "3": "Goed! 675 heeft honderdtal 6 en tientalcijfer 7 — het grootst van alle vier."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-002",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een kassamedewerker zoekt het kleinste bedrag. Welk getal is het kleinst?",
      "context": null,
      "options": ["234", "243", "324", "342"],
      "correctAnswer": 0,
      "conceptId": "compare_smallest",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.62,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kleinste getal vinden", "content": "Vergelijk de honderdtallen eerst. Het kleinste honderdtal geeft het kleinste getal.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De kassamedewerker vergelijkt de honderdtallen: 2, 2, 3, 3. De getallen met honderdtal 2 zijn het kleinst (234 en 243). Dan de tientallen: 3 en 4. Omdat 3 < 4, is 234 het kleinst.",
        "solutionSteps": [
          "Vergelijk de honderdtallen: 2, 2, 3, 3",
          "Honderdtal 2 < 3 → 234 en 243 zijn kleiner",
          "Vergelijk de tientallen: 3 vs 4 → 234 < 243",
          "Antwoord: 234"
        ],
        "distractorExplanations": {
          "0": "Goed! 234 heeft honderdtal 2 en tientalcijfer 3 — het kleinste van alle vier.",
          "1": "Je dacht waarschijnlijk dat 243 het kleinst is. Maar 243 heeft tientalcijfer 4, en 234 heeft tientalcijfer 3. Omdat 3 < 4, is 234 kleiner. Onthoud: bij gelijke honderdtallen vergelijk je de tientallen.",
          "2": "Je dacht waarschijnlijk dat 324 het kleinst is. Maar honderdtal 3 > 2. De getallen met honderdtal 2 zijn kleiner. Onthoud: vergelijk altijd eerst de honderdtallen.",
          "3": "Je dacht waarschijnlijk dat 342 het kleinst is. Maar honderdtal 3 > 2, en tientalcijfer 4 > 3. 342 is juist het grootst. Onthoud: vergelijk altijd eerst de honderdtallen."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-003",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een magazijnmedewerker sorteert dozen. Zet deze getallen van klein naar groot: 89, 98, 809, 890",
      "context": null,
      "options": [
        "89 - 98 - 809 - 890",
        "89 - 98 - 890 - 809",
        "98 - 89 - 809 - 890",
        "809 - 890 - 89 - 98"
      ],
      "correctAnswer": 0,
      "conceptId": "order_mixed_digits",
      "variantIndex": 3,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.68,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Getallen ordenen", "content": "Meer cijfers = groter getal. 3-cijferige getallen zijn altijd groter dan 2-cijferige getallen.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De magazijnmedewerker sorteert: 2-cijferige getallen (89, 98) zijn kleiner dan 3-cijferige getallen (809, 890). Van de 2-cijferige: 89 < 98. Van de 3-cijferige: 809 < 890.",
        "solutionSteps": [
          "Groepeer: 2-cijferig (89, 98) en 3-cijferig (809, 890)",
          "2-cijferig < 3-cijferig",
          "89 < 98 (tientalcijfer 8 < 9)",
          "809 < 890 (tientalcijfer 0 < 9)",
          "Volgorde: 89 - 98 - 809 - 890"
        ],
        "distractorExplanations": {
          "0": "Goed! 89 < 98 (2-cijferig), dan 809 < 890 (3-cijferig).",
          "1": "Je dacht waarschijnlijk dat 890 < 809. Maar vergelijk de tientallen: 0 < 9, dus 809 < 890. Onthoud: bij gelijke honderdtallen vergelijk je de tientallen.",
          "2": "Je dacht waarschijnlijk dat 98 < 89. Maar tientalcijfer 8 < 9, dus 89 < 98. Onthoud: bij gelijke aantallen cijfers vergelijk je van links naar rechts.",
          "3": "Je dacht waarschijnlijk dat 3-cijferige getallen kleiner zijn. Maar meer cijfers = groter getal. 809 en 890 zijn groter dan 89 en 98. Onthoud: meer cijfers = groter."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-004",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een sportcoach vergelijkt scores. Welk teken hoort tussen deze getallen? 1.234 ... 1.243",
      "context": null,
      "options": ["<", ">", "=", "≠"],
      "correctAnswer": 0,
      "conceptId": "compare_symbols",
      "variantIndex": 4,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.7,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Vergelijkingstekens", "content": "< betekent 'kleiner dan'. > betekent 'groter dan'. = betekent 'gelijk aan'.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De sportcoach vergelijkt: 1.234 en 1.243 hebben dezelfde duizendtallen (1) en honderdtallen (2). Vergelijk de tientallen: 3 < 4. Dus 1.234 < 1.243.",
        "solutionSteps": [
          "Duizendtallen: 1 = 1 → gelijk",
          "Honderdtallen: 2 = 2 → gelijk",
          "Tientallen: 3 < 4 → 1.234 is kleiner",
          "Teken: <"
        ],
        "distractorExplanations": {
          "0": "Goed! Tientalcijfer 3 < 4, dus 1.234 < 1.243.",
          "1": "Je dacht waarschijnlijk dat 1.234 groter is. Maar tientalcijfer 3 < 4, dus 1.234 < 1.243. Het teken moet < zijn, niet >. Onthoud: het open puntje wijst naar het kleinste getal.",
          "2": "Je dacht waarschijnlijk dat ze gelijk zijn. Maar 1.234 ≠ 1.243 — ze verschillen in het tientalcijfer (3 vs 4). Onthoud: vergelijk alle posities.",
          "3": "Je dacht waarschijnlijk dat ≠ het juiste teken is. Ze zijn inderdaad ongelijk, maar de vraag vraagt welk vergelijkingsteken past. Het juiste teken is < (kleiner dan). Onthoud: < en > geven de richting aan."
        }
      }
    },
    {
      "id": "GET-GROOT-VERGELIJK-005",
      "familyId": "GET-GROOT-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "skill": "positiestelsel",
      "subSkill": "groot_vergelijken",
      "questionType": "multiple_choice",
      "question": "Een postbode sorteert huisnummers. Welk getal ligt het dichtst bij 500?",
      "context": null,
      "options": ["498", "510", "480", "520"],
      "correctAnswer": 0,
      "conceptId": "compare_closest_to",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.69,
      "group": 6,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Dichtst bij een getal", "content": "Bereken het verschil met 500 voor elk getal. Het kleinste verschil = het dichtst bij. 498: verschil = 2. 510: verschil = 10. 480: verschil = 20. 520: verschil = 20.", "icon": "lightbulb" } }
      ],
      "feedback": {
        "explanationText": "De postbode berekent het verschil met 500 voor elk getal. 498: 500 − 498 = 2. 510: 510 − 500 = 10. 480: 500 − 480 = 20. 520: 520 − 500 = 20. Het kleinste verschil is 2, dus 498 ligt het dichtst bij 500.",
        "solutionSteps": [
          "Bereken het verschil met 500 voor elk getal",
          "498: verschil = 2",
          "510: verschil = 10",
          "480: verschil = 20, 520: verschil = 20",
          "Kleinste verschil = 2 → antwoord: 498"
        ],
        "distractorExplanations": {
          "0": "Goed! 498 ligt maar 2 van 500 af — het dichtst bij.",
          "1": "Je dacht waarschijnlijk dat 510 het dichtst bij is. Maar 510 − 500 = 10, en 500 − 498 = 2. Omdat 2 < 10, is 498 dichterbij. Onthoud: bereken het verschil.",
          "2": "Je dacht waarschijnlijk dat 480 het dichtst bij is. Maar 500 − 480 = 20, en 500 − 498 = 2. Omdat 2 < 20, is 498 dichterbij. Onthoud: bereken het verschil.",
          "3": "Je dacht waarschijnlijk dat 520 het dichtst bij is. Maar 520 − 500 = 20, en 500 − 498 = 2. Omdat 2 < 20, is 498 dichterbij. Onthoud: bereken het verschil."
        }
      }
    }
  ]
}